import { prodOpenAIAPI } from '../constants/api-urls';

export async function callAI(question = "what is Nate's favorite color?") {
  const aiAPIURL = prodOpenAIAPI;
  const url = `${aiAPIURL}?question=${question}`;
  const response = await fetch(url, { mode: 'cors' });
  const aiResponse = await response.json();

  return aiResponse;
}
